<script setup lang="ts">
import Divider from '@/components/Divider/DividerItem.vue'
import { StackLayout } from '@/components/Layouts'
import type { EColors } from '@/types/constants/ColorValues'

type Props = {
    title?: string
    subtitle?: string
    withDivider?: boolean
    type?: EColors
    gap?: number
}
withDefaults(defineProps<Props>(), { gap: 4 })
</script>

<template>
    <StackLayout direction="column" :gap="gap">
        <p :class="`title is-spaced ${type ? `is-${type}` : ''}`" v-bind="$attrs">
            <slot name="title">
                {{ title }}
            </slot>
        </p>
        <Divider v-if="withDivider && !!subtitle" variant="middle" />
        <p v-if="!!subtitle" :class="`subtitle ${type ? `is-${type}` : ''}`">
            <slot name="subtitle">
                {{ subtitle }}
            </slot>
        </p>
    </StackLayout>
</template>
